import { Subject, BehaviorSubject, timer, of } from 'rxjs'
import { Component, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core'
import { map, switchMap } from 'rxjs/operators'

export type Switcher = {
    loading$: BehaviorSubject<boolean>
    checked$: BehaviorSubject<boolean>
    onChange: (newState: boolean) => void
}

@Component({
    selector: 'app-async-switcher',
    templateUrl: './async-switcher.component.html',
    styleUrls: ['./async-switcher.component.scss'],
})
export class AsyncSwitcherComponent implements OnInit, OnChanges {
    @Input() checked = false
    @Input() switcherId: string = Date.now().toString()

    @Input() loadingControl = false
    @Input() disabled = false

    @Output() checkedChange = new Subject<boolean>()

    allowLoadingSpinner = true

    private _loadingControl$ = new Subject<boolean>()

    isLoading$: any

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['loadingControl'])
            this._loadingControl$.next(changes['loadingControl'].currentValue)
    }

    ngOnInit(): void {
        this.isLoading$ = this._loadingControl$.pipe(
            switchMap(value => {
                if (value) return timer(60).pipe(map(() => value))
                else return of(value)
            }),
        )
    }

    getEventValue(event: Event) {
        const target = event.target as HTMLInputElement
        return target.checked
    }
}
